import { TaskType } from '@/config/task';
import { TaskInfo } from '@tencent/wphk-act-base-cgi';
import { ExecConf } from './config-type';

/** 任务信息 */
export type TaskItem = {
  /** 任务ID，例如：P2P_PAY */
  id: string;
  /** 权重 */
  order: number;
  /** 任务类型 */
  type: TaskType;
  /** 任务名称 */
  name: string;
  /** 任务规则 */
  rule: string;
  /** 每天最多完成任务的次数 */
  maxTimesPerDay?: number;
  /** 每个周期最多完成任务的次数 */
  maxTimesPerStage: number;
  /** 每次完成获得奖品个数 */
  prizeCountPerTime: number;
  /** 已完成次数 */
  finishCount: number;
  /** 任务状态 */
  status: TaskStatus;
  /** 开始时间 */
  startTime: Date;
  /** 结束时间 */
  endTime: Date;
  /** 跳转信息 */
  jumpInfo?: JumpInfo;
  /** 执行任务信息 */
  execConf?: ExecConf;
  /** 任务已派印花数量 */
  taskSendCnt: number;
  /** 任务总限额 */
  taskTotalCnt: number;
  /** 任务限额配置 */
  taskSendLimit: number;
  /** 【本周期】单次任务信息 - 完成一次任务记录一条信息（如：完成所需资格数，已获得资格数，完成时间，等等） */
  taskInfoDetail: TaskInfo[];
  /** 任务logo */
  taskLogo: string;
};

/** 任务状态 */
export enum TaskStatus {
  /** 未开始 */
  notStart,
  /** 进行中 */
  inProgress,
  /** 已结束 */
  outdate,
  /** 已派完 - 针对有限额的任务 */
  soldOut
}

/** 任务跳转信息 */
export type JumpInfo = {
  mode: 'h5';
  url: string;
} | {
  mode: 'mp';
  path: string;
  username: string;
};


/** 执行任务类型 */
export enum ExecTaskType  {
  /** 自动任务 */
  auto = 'auto',
  /** 主动任务 */
  manual = 'manual'
}
